import Text from '../Base/Text/Text';

export default function QuestionnaireItem(props) {
	const { user, onClick, selected } = props;

	const handleClick = () => {
		onClick?.({
			id: user.id,
			label: user.label,
		});
	};

	return (
		<div
			className={`autocomplete-custom-patient-search no-border ${
				selected ? 'active' : ''
			}`}
			onClick={handleClick}>
			<div className='autocomplete-tags__item__checkbox' />
			<div className='autocomplete-custom-patient-search__content'>
				<div className='autocomplete-custom-patient-search__content__title'>
					<Text tx={user.label} />
				</div>
			</div>
		</div>
	);
}

QuestionnaireItem.propTypes = {};
